import {PixelRatio, Platform, StyleSheet, TextStyle, ViewStyle} from 'react-native';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import {rewardStatusConfig} from 'src/components/elements/rewards/rewardsstatus/rewardStatusHelper';
import Styles from 'src/components/Styles';

export function getStyleDescriptor(): {
  [index: string]: ViewStyle & TextStyle;
} {
  return {
    userPointsNameTitle: {
      fontWeight: '700',
      fontSize: Styles.Fonts.headerFont,
      fontFamily: rewardStatusConfig.textFontFamily,
    },
    statusExpires: {
      fontWeight: '300',
      fontStyle: 'italic',
      fontSize: Styles.Fonts.f1,
      fontFamily: rewardStatusConfig.textFontFamily,
    },
    userPointsValueTitle: {
      fontWeight: '400',
      fontSize: Styles.Fonts.sectionHeader,
      fontFamily: rewardStatusConfig.textFontFamily,
    },
    userTierName: {
      paddingLeft: Styles.Spacing.m1,
      textAlign: 'center',
      fontSize: Styles.Fonts.f7,
      fontFamily: rewardStatusConfig.textFontFamily,
      fontWeight: '400',
    },
    tierIconAndName: {
      flex: 1,
      flexDirection: 'row',
      marginTop: 22,
      justifyContent: 'flex-start',
      alignSelf: 'flex-start',
    },
    howManyPoints: {
      paddingLeft: Styles.Spacing.m1,
      textAlign: 'center',
      marginTop: 10,
      fontWeight: '400',
      fontSize: Styles.Fonts.f8,
      fontFamily: rewardStatusConfig.textFontFamily,
    },
    pointsAway: {
      fontWeight: '700',
      fontSize: Styles.Fonts.sectionHeader,
      fontFamily: rewardStatusConfig.textFontFamily,
      paddingTop: Styles.Spacing.m3,
      textAlign: 'left',
      textTransform: 'capitalize',
    },
    discalimerText: {
      fontWeight: '400',
      fontStyle: 'italic',
      fontSize: Styles.Fonts.f1,
      paddingTop: Styles.Spacing.m3,
      fontFamily: rewardStatusConfig.textFontFamily,
      textAlign: 'left',
    },
    pointsMultiplier: {
      fontWeight: '400',
      fontSize: Styles.Fonts.f1,
      paddingTop: Styles.Spacing.m2,
      fontFamily: rewardStatusConfig.textFontFamily,
      textAlign: 'center',
    },
    exclRewards: {
      fontWeight: '700',
      fontFamily: rewardStatusConfig.textFontFamily,
      fontSize: Styles.Fonts.f1,
      paddingTop: Styles.Spacing.m2,
      textAlign: 'center',
    },
    container: {
      marginTop: Styles.Spacing.m3,
      paddingHorizontal: Styles.Spacing.m3,
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    flex1: {
      flex: 1,
    },
    flex15: {
      flex: 15,
    },
    line: {
      alignItems: 'center',
      alignSelf: 'stretch',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      marginBottom: Styles.Spacing.m1,
    },
    payGraph: {
      alignSelf: 'stretch',
      flexDirection: 'row',
      marginTop: Styles.Spacing.m2,
    },
    payAvailableOption: {
      height: PixelRatio.roundToNearestPixel(12),
    },
    firstSection: {
      borderBottomLeftRadius: Styles.Spacing.m3,
      borderTopLeftRadius: Styles.Spacing.m3,
    },
    lastSection: {
      borderBottomRightRadius: Styles.Spacing.m3,
      borderTopRightRadius: Styles.Spacing.m3,
    },
    payUnavailableOption: {
      height: PixelRatio.roundToNearestPixel(12),
      backgroundColor: Styles.Colors.PayNew.neutralHuesBase09,
    },
    divider: {
      backgroundColor: Styles.neutralHues,
      height: StyleSheet.hairlineWidth,
      width: '97%',
      paddingBottom: 1,
    },
    titleHead: {
      gap: Styles.Spacing.m2,
    },
    tierContainer: {
      gap: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m1,
    },
    roundIndicatorStyle: {
      width: Platform.OS === 'web' ? Styles.Spacing.m0 : Styles.Spacing.m3 + 1,
      height:
        Platform.OS === 'web'
          ? Styles.Spacing.m0
          : Styles.Spacing.m1 + Styles.Spacing.m2,
      zIndex: 99999,
      alignSelf: 'flex-end',
      alignItems: 'flex-end',
      left: 5,
      elevation: 9,
      top: -4,
    },
    rewardOption: {
      flexDirection: 'row',
    },
    circleIndicatorShadow: {
      zIndex: -1,
      height: 2,
      shadowColor: '#000000',
      shadowOffset: {width: 1, height: 1},
      shadowOpacity: 0.5,
      shadowRadius: 1,
      elevation: 5,
    },
    productItem: {
      width: 164,
      height: 159,
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 12,
      paddingHorizontal: 12,
      paddingTop: Styles.Spacing.m3,
      paddingBottom: Styles.Spacing.m4,
      borderRadius: Styles.Spacing.m2,
      ...getLayoutDescriber().shadowStyles().lightShadow,
    },
    productTierPoints: {flexDirection: 'row', alignItems: 'center', gap: 4},
    productListContainer: {
      gap: Styles.Spacing.m2,
      paddingBottom: 4, // to avoid shadow clipping
    },
    productName: {width: '100%', flexGrow: 1, textAlign: 'center'},
    disabled: {
      opacity: 0.6,
    },
    pngFallback: {
      width: Styles.Spacing.m4 - Styles.Spacing.m1,
      height: Styles.Spacing.m4 - Styles.Spacing.m1,
    },
  };
}

export default {
  getStyleDescriptor,
};
